import { memo, useMemo } from "react";
import { IonLabel } from "@ionic/react";
import { IonIcon } from "@ionic/react";
import s from "./AttemptCounts.module.scss";
import { XCloseIcon } from "../../../../assets/icons";
import { useWebUserStore } from "../../../../CommonStores";
import { shallow } from "zustand/shallow";
import cx from "classnames";
import { useBreakpoint } from "../../../../../Common/utils/common";
import Stripe from "stripe";

const AttemptCounts = () => {
  const [user, latestFailedStripePaymentAttempt] = useWebUserStore(
    (store) => [store.user, store.latestFailedStripePaymentAttempt],
    shallow
  );
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === "mobile";

  const paymentAttempts = latestFailedStripePaymentAttempt
    ? (latestFailedStripePaymentAttempt?.data.object as Stripe.Invoice)
        .attempt_count || 0
    : 0;

  const getOrdinalNumber = (num: number): string => {
    const lastDigit = num % 10;
    const lastTwoDigits = num % 100;

    // Handle special cases for 11th, 12th, 13th
    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
      return `${num}TH`;
    }

    // Handle other cases
    switch (lastDigit) {
      case 1:
        return `${num}ST`;
      case 2:
        return `${num}ND`;
      case 3:
        return `${num}RD`;
      default:
        return `${num}TH`;
    }
  };

  const renderAttempts = useMemo(() => {
    const attempts = [];
    for (let i = 1; i <= paymentAttempts; i++) {
      const ordinalNumber = getOrdinalNumber(i);
      const numberPart = ordinalNumber.replace(/[A-Z]+$/, "");
      const suffixPart = ordinalNumber.replace(/^\d+/, "");

      attempts.push(
        <div key={i} className={s.attempt}>
          <IonLabel className={s.attemptNumber}>
            {isMobile ? (
              <>
                {numberPart}
                <sup>{suffixPart}</sup>
              </>
            ) : (
              ordinalNumber
            )}
          </IonLabel>
          <div className={s.statusContainer}>
            <div className={s.iconOutline}>
              <div className={s.iconContainer}>
                <XCloseIcon className={s.failedIcon} />
              </div>
            </div>
            <IonLabel className={s.statusText}>FAILED</IonLabel>
          </div>
        </div>
      );

      // Only add line if there's a next attempt
      if (i < paymentAttempts) {
        attempts.push(<div key={`line-${i}`} className={s.line}></div>);
      }
    }
    return attempts;
  }, [user, paymentAttempts, isMobile]);

  return (
    <div className={cx(s.attemptCounts, { [s.mobile]: isMobile })}>
      <div className={s.content}>
        <div className={s.header}>
          <IonLabel className={s.mainTitle}>
            YOUR LAST PAYMENT DID NOT GO THROUGH!
          </IonLabel>
        </div>

        <div className={s.body}>
          <IonLabel className={s.sectionTitle}>PAYMENT ATTEMPTS</IonLabel>

          <div className={s.attemptsContainer}>{renderAttempts}</div>
        </div>
      </div>
    </div>
  );
};

export default memo(AttemptCounts);
